import * as types from "../../actions/actionTypes";

const initialState = {
  criterions: [],
  criterionSelected: {}
};

const criterionReducer = (state = initialState, action) => {
  switch (action.type) {
    case types.ADD_CRITERION:
      return { ...state, criterions: [...state.criterions, {...action.criterion, type:action.criterion.type.toUpperCase()}] };
    case types.UPDATE_CRITERION_SELECTED: {
      let crits = state.criterions.slice();
      for (let i = 0; i < crits.length; i++) {
        if (crits[i].name === state.criterionSelected.name) {
          crits.splice(i, 1);
          break;
        }
      }
      crits.push({...action.criterion, type:action.criterion.type.toUpperCase()});

      return { ...state, criterions: crits };
    }
    case types.REMOVE_CRITERION: {
      let crits = state.criterions.slice();
      for (let i = 0; i < crits.length; i++) {
        if (crits[i].name === action.criterionName) {
          crits.splice(i, 1);
          break;
        }
      }
      return { ...state, criterions: crits };
    }
    case types.CLEAN_CRITERIONS:
      return { ...state, criterions: [], criterionSelected: {} };
    case types.SELECT_CRITERION:
      return { ...state, criterionSelected: action.criterionSelected };
    default:
      return state;
  }
};

export default criterionReducer;



// WEBPACK FOOTER //
// ./src/reducers/pomui/criterionReducer.js